<template>
     <div class="dashproviderservice">
         <PageTitle icon="fa fa-clone" main="Record" sub="Service Order"/>
             <b-card title="Record Service Order" body-class="text-center">
                <b-tabs card >
                   <b-tab title="Open" active>
                    <b-table 
                        class="table-responsive" 
                        hover 
                        head-variant="dark" 
                        :items="openserviceorderopen" 
                        :fields="fieldsOpen">
                    <template v-slot:cell(actions)="data">
                            <b-button  
                                title = "Detail" 
                                size="sm" 
                                variant="light" 
                                id="popover-button-sync"
                                class="mr-2 mt-2">
                                <i class="fa fa-comment-o"></i>
                            </b-button> 
                              <b-popover :show.sync="show" target="popover-button-sync" title="Detail">
                                {{data.item.name_default_service_type}} - {{data.item.comment_open_service}}
                             </b-popover>
                            <b-button  
                                v-if="!data.item.date_in_open_service"
                                title = "Start" 
                                size="sm" 
                                @click="showMsgBoxStart(data.item.id)"
                                variant="light" 
                                class="mr-2 mt-2">
                                <i class="fa fa-unlock"></i>
                            </b-button>          
                            <b-button  
                                v-if="data.item.date_in_open_service"
                                title = "End" 
                                size="sm" 
                                @click="showMsgBoxEnd(data.item.id)"
                                variant="light" 
                                class="mr-2 mt-2">
                                <i class="fa fa-unlock-alt"></i>
                            </b-button>
                        </template>    
                    </b-table> 
                   </b-tab>
                    <b-tab title="Closed">
                         <b-table 
                        class="table-responsive" 
                        hover 
                        head-variant="dark" 
                        :items="openserviceorderclosed" 
                        :fields="fieldsClosed">
                    <!--template v-slot:cell(actions)="data">
         
                            <b-button  
                                v-if="!data.item.date_in_open_service"
                                title = "Start" 
                                size="sm" 
                                variant="light" 
                                class="mr-2 mt-2">
                                <i class="fa fa-check-square-o"></i>
                            </b-button>          
                        </template-->    
                    </b-table> 
                   </b-tab>
                </b-tabs>

              
            </b-card>
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
var moment = require('moment')

export default {
         name: 'DashProviderService',
            directives: {moment},
                data: function() {
                return {
                    mode: 'insert',
                    search: '',
                     show: false,
                    defaultservicetype: {},
                    defaultservicetypes: [],
                    openserviceorderopen:[],
                    openserviceorderclosed:[],
                    showSearch: true,
                    isBusy: false,
                    fieldsOpen: [
                    {key: 'date_open_service',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'description_open_service', label: 'Location', sortable: false ,variant: 'light'},
                    {key: 'date_in_open_service',label: 'In',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('HH:mm') : '',variant: 'light'
                    },
                    { key: 'actions', label: 'Action',variant: 'light' }
                    ],
                    fieldsClosed: [
                    {key: 'date_open_service',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'description_open_service', label: 'Location', sortable: false ,variant: 'light'},
                    {key: 'date_in_open_service',label: 'In',sortable: false,
                            formatter: value =>
                            value ? moment(value).format('HH:mm') : '',variant: 'light'
                    },
                    {key: 'date_out_open_service',label: 'Out',sortable: false,
                            formatter: value =>
                            value ? moment(value).format('HH:mm') : '',variant: 'light'
                    },
                    { key: 'value_total_open_service', label: 'Payment', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'actions', label: 'Action',variant: 'light' },

                ],
                }
            },
            computed: {
                user(){
                    return this.$store.state.user
                },
                compan(){
                    return this.$store.state.compan
                },
                filteredList() {
                return this.defaultservicetypes.filter(defaultservicetype => {
                return defaultservicetype.name_default_service_type.toLowerCase().includes(this.search.toLowerCase())
                    })
                },
                icon() {
                    return this.showTable ? "fa-retweet" : "fa-search"
                },
                 rows() {
                    return this.defaultservicetypes.length
                }
            },
            methods: {
                async showMsgBoxStart(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to start the work order?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.start(item)
                    }
                })
            },
             async showMsgBoxEnd(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to finalize the work order?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.end(item)
                    }
                })
            },
            async start(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/openserviceorderstart/${item}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadServiceOrderOpen()

                        })
                        .catch(showError)

           },
            async end(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/openserviceorderend/${item}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadServiceOrderOpen()
                            this.loadServiceOrderClosed()

                        })
                        .catch(showError)

           },
            formatDate (date) {
                return moment(date).format('YYYY-MM-DD')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadParts() {
                const url = `${baseApiUrl}/defaultservicetypesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.defaultservicetypes = res.data
                     this.isBusy = false
            })
            },
            reset() {
                this.mode = 'insert'
                this.loadParts()
            },
            alterModo() {
                        this.mode = 'save'
                        this.defaultservicetype = {}
                        this.$refs.searchFocus.focus();
                },
            save() {

          
                    this.defaultservicetype = {
                        ...this.defaultservicetype,
                        company_id_default_service_type: this.compan.id,
                        user_id_default_service_type: this.user.id
                    }
                   
                const method = this.defaultservicetype.id ? 'put' : 'post'
                const id = this.defaultservicetype.id ? `/${this.defaultservicetype.id}` : ''
                axios[method](`${baseApiUrl}/defaultservicetypes${id}`, this.defaultservicetype)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                const id = this.defaultservicetype.id
                axios.delete(`${baseApiUrl}/defaultservicetypes/${id}`)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                    })
                    .catch(showError)
            },
            loadPart(defaultservicetype, mode = 'save') {
                this.mode = mode
                this.defaultservicetype = { ...defaultservicetype }
                this.$refs.searchFocus.focus();
            },
            loadServiceOrderOpen(){
                const url = `${baseApiUrl}/openserviceorderbyopen/${this.compan.id}/?user_service_provider_id=${this.user.id}`
                axios(url).then(res =>{
                     this.openserviceorderopen = res.data
                })

            },
            loadServiceOrderClosed(){
                const url = `${baseApiUrl}/openserviceorderbyclosed/${this.compan.id}/?user_service_provider_id=${this.user.id}`
                axios(url).then(res =>{
                     this.openserviceorderclosed = res.data
                })

            },
                
             },
            mounted() {
                this.showTable = true
                this.loadServiceOrderOpen()
                this.loadServiceOrderClosed()
            }
    }       
</script>

<style>

     .dashproviderservice label {
        font-size: 0.75rem;
        color: black;
    }

    .dashproviderservice select{
        font-size: 0.75rem;
    }
    .dashproviderservice input{
        font-size: 0.75rem;
    }
    .dashproviderservice textarea{
        font-size: 0.75rem;
    }
    .dashproviderservice button{
        font-size: 0.75rem;
    }
    .dashproviderservice table{
        font-size: 0.75rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
